export const PUBLIC_FOOTER_SCHEMA = {
  en: {
    description: "Smart Match. Clear Filing. Max Refund.",
    col1: {
      heading: "For Users",
      link2: {
        text: "Let’s File",
      },
      link3: {
        text: "Join as a Tax Pro",
      },
      link4: {
        text: "FAQ",
      },
      link5: {
        text: "Help Center",
      },
    },
    col2: {
      heading: "Company",
      link1: {
        text: "What We Offer",
      },
      link2: {
        text: "Who We Help",
      },
      link3: {
        text: "Blog",
      },
    },
    col3: {
      heading: "Get to Know Us",
      link1: {
        text: "About Us",
      },
      link2: {
        text: "Follow Us",
      },
    },
    closing_page: {
      heading: "Your Financial Home",
      description: "Where every part of your financial life works together.",
      image_alt: "Get Started",
      ctas: [
        { text: "Get Started", link: "/sign-up" },
        { text: "Log In", link: "/sign-in" },
      ],
    },
  },
};
